export default __webpack_public_path__ + "static/media/rating-star.040d241f.png";